/**
 * The format of a texture - corresponds to the Babylon.js TextureFormat constants
 */
export var TextureFormat;
(function (TextureFormat) {
    /** Babylon Constants.TEXTUREFORMAT_RGBA */
    TextureFormat[TextureFormat["RGBA"] = 5] = "RGBA";
    /** Babylon Constants.TEXTUREFORMAT_R */
    TextureFormat[TextureFormat["R"] = 6] = "R";
    /** Babylon Constants.TEXTUREFORMAT_RG */
    TextureFormat[TextureFormat["RG"] = 7] = "RG";
})(TextureFormat || (TextureFormat = {}));
/**
 * The type of a texture - corresponds to the Babylon.js TextureType constants
 */
export var TextureType;
(function (TextureType) {
    /** Babylon Constants.TEXTURETYPE_UNSIGNED_BYTE */
    TextureType[TextureType["UNSIGNED_BYTE"] = 0] = "UNSIGNED_BYTE";
    /** Babylon Constants.TEXTURETYPE_FLOAT */
    TextureType[TextureType["FLOAT"] = 1] = "FLOAT";
    /** Babylon Constants.TEXTURETYPE_HALF_FLOAT */
    TextureType[TextureType["HALF_FLOAT"] = 2] = "HALF_FLOAT";
})(TextureType || (TextureType = {}));
/**
 * Compares two OutputTextureOptions to see if they match.
 * @param a - The first OutputTextureOptions
 * @param b - The second OutputTextureOptions
 * @returns True if the two options match, false otherwise
 */
export function TextureOptionsMatch(a, b) {
    if (a === undefined || b === undefined) {
        return false;
    }
    return a.ratio === b.ratio && a.format === b.format && a.type === b.type;
}
//# sourceMappingURL=textureOptions.js.map